// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/bordered.less
// module id = 96
// module chunks = 0